/**
 * @constant
 */
const EconomyTypes = {
    PORKER_PRICE: "PorkerPrice", // cena za 1kg tucznika
    PIG_FALL_PRICE: "PigFallPrice", // cena upadku prosiaka
    PIGLET_FALL_PRICE: "PigletFallPrice", // cena upadku warchlaka
    PORKER_FALL_PRICE: "PorkerFallPrice", // cena upadku tucznika
    RENOVATION_SOW_FALL_PRICE: "RenovationSowFallPrice", // cena upadku loszki
    SOW_FALL_PRICE: "SowFallPrice", // cena upadku maciory
    WATER: "Water", // cena za 1m3 wody,
    ELECTRICITY: "Electricity", // cena za 1kWh pradu
    EMPLOYEES: "Employees", // koszt utrzymania pracowników na miesiąc
    LOAN: "Loan", // rata kredytu
    CURRENCY: "Currency"
};

module.exports = EconomyTypes;
